import { AuthContextProvider } from './contexts/AuthContext';
import { ConfigContextProvider } from './contexts/ConfigContext';
import { PlayerContextProvider } from './contexts/PlayerContext';
import { SettingsContextProvider } from './contexts/SettingsContext';
import './fonts/fonts.css';
import './index.css';
import loggerService from './utils/logger';

type AppProps = {
  children: React.ReactNode;
};

function App({ children }: AppProps): JSX.Element {
  loggerService?.info('player version:', import.meta.env.VITE_APP_VERSION);

  return (
    <SettingsContextProvider>
      <ConfigContextProvider>
        <AuthContextProvider>
          <PlayerContextProvider>
            {children}
          </PlayerContextProvider>
        </AuthContextProvider>
      </ConfigContextProvider>
    </SettingsContextProvider>
  );
}

export default App;
